import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import paginationFactory, {PaginationProvider,} from "react-bootstrap-table2-paginator";
import {headerSortingClasses, NoRecordsFoundMessage, PleaseWaitMessage, sortCaret} from "../../../_metronic/_helpers";
import * as uiHelpers from "./OrdersUIHelpers";
import {Pagination} from "../../../_metronic/_partials/controls";
import * as columnFormatters from "./column-formatters";
import {useOrdersUIContext} from "./OrdersUIContext";
import {useHistory} from "react-router-dom";
import moment from "jalali-moment";

export default function OrdersTable({
                                         orders,
                                     }) {

    const productContext = useOrdersUIContext();
    const {SearchBar} = Search;
    const history = useHistory();

    const handleEdit = (id) => {
        history.push(`/customer/orders/${id}`);
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شناسه سفارش",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "product_id",
            text: "شناسه محصول",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "user_id",
            text: "شناسه کاربر",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "price",
            text: "قیمت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "quantity",
            text: "تعداد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "variant",
            text: "سایز",
            sort: true,
            formatter: (data) => {
                if (data) return `${data.attributeName} - ${data.attributeType} - ${data.attributeValue}`
            }
        },
        {
            dataField: "status.name",
            text: "وضعیت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD HH:mm:ss');
                return <>{createdDate}</>;
            },
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPage: handleEdit,
                dealerDeleteClick: productContext.handleDelete
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: orders.length,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: 15,
        page: 1,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({paginationProps, paginationTableProps}) => {
                    return (
                        <Pagination
                            isLoading={false}
                            paginationProps={paginationProps}
                        >
                            <ToolkitProvider
                                keyField="priority"
                                data={orders}
                                columns={columns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr/>
                                            <BootstrapTable
                                                wrapperClasses="table-responsive"
                                                bordered={false}
                                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                                bootstrap4
                                                defaultSorted={uiHelpers.defaultSorted}
                                                {...paginationTableProps}
                                                {...props.baseProps}
                                            >
                                                <PleaseWaitMessage entities={orders}/>
                                                <NoRecordsFoundMessage entities={orders}/>
                                            </BootstrapTable>
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    )
}